export const Color = {
  black: '#222222',
  baseColor: '#F7F5F9',
  foreColor: '#FEFEFE',
  white: '#fff',
  whiteTransparent: '#ffffffdd',
  blackTransparent: '#222222AB',
  gray: '#878787',
  grayLight: '#DADADA',
  grayLight2: '#ECECEC',
  grayLight3: '#F5F5F5',
  grayLight4: '#B5B0CB',
  grayHue2: '#3d4447',
  grayHue3: '#212121',
  grayHue4: '#e0e0e0',
  grayHue5: '#bbb',
  grayHue6: '#a5a4a5',
  grayHue7: '#E1E1E1',
  grayHue8: '#AFAEB1',
  blueHue2: '#3a75b9',
  blueHue3: '#29abe2',
  blueHue4: '#ccdff1',
  blueHue5: '#f2f5f9',
  blueHue6: '#003366',
  blueHue7: '#007aff',
  blueHue8: '#006CF0',
  blueHue9: '#7CD6E2',
  blueHue10: '#C3DAE9',
  blueHue11: '#1b164f',
  primary: '#110057',
  primaryHue2: '#036',
  primaryHue3: '#38d',
  primaryHue5: '#00A9DF',
  primaryHue6: '#1166BB',
  lightBlue: '#76DDFB',
  tealBlue: '#54ADA7',
  selectHealth: '#4e8a03',
  scripius: '#4e8a03',
  scripiusBlue: '#120B57',
  scripiusHover: '#3e6e02',
  scripiusLightHover: '#d3e3bf',
  secondary: '#4A00E2',
  secondaryHue3: '#4aa0b5',
  tertiary: '#7CAFD0',
  accent: '#FF5D55',
  accentTint: '#FF8882',
  textLight: '#444444',
  textDark: '#222222',
  inverted: '#fff',
  baseDark: '#ccc',
  tealLight: '#6DC9D8',
  tealTint: '#D1ECF1',
  cyanBlueLight: '#C4DBF3',
  tableRowLight: '#e0eff3',
  tableCellDark: '#19b1c9',
  tableHeadDark: '#17A2B8',
  blueCardText: '#282F66',

  cobaltTint: '#E7E6EE',
  cobaltTint2: '#9988F0',
  greenShade: '#b0d9d6',
  darkGreenShade: '#00857C',
  darkOrangeShade: '#FFAA45',
  darkGrayShade: '#686769',

  MHlogoDarkBlue: '#025EA9',
  MHlogoLightBlue: '#4E83C2',

  orange: '#FF9400',
  // Booking specific
  golden: '#FFBB22',
  lightGolden: '#FBEECA',

  yellow: '#fEE44D',
  lightYellow: '#fffde6',
  starRatingYellow: '#FFBB22',
  billDueOrange: '#DE6902',
  red: '#E80036',
  salmon: '#EA5B55',
  redLight: '#FBE5E6',
  green: '#75A201',
  purple: '#512EA8',
  lightPurple: '#7E4EF2',
  magenta: '#bf13e6',
  magentaHover: '#8C00CD',
  magentaLightHover: '#f9e7fd',
  defaultProvider: '#70669A',
  accentHue3: '#EDE8FB',
  buttonDisabled: '#bfbfbf',
  inputBackground: '#fafafa',
  inputPlaceholderText: '#bbb',
  translucent: 'rgba(255, 255, 255, 0.3)',
  transparent: 'transparent',
  link: '#4A00E2',
  linkLight: '#B5B0CB',
  // custom colors
  grayLight5: '#fffeff',
  grayLight6: '#bdbdbd',
  grayLight7: '#D8D8D8',
  grayLight8: '#E7E6EE',
  grayDark: '#818181',
  grayLight9: '#dbd8d3',
  grayLight10: '#e1dfe3',
  greenLightDark: '#447722',
  // random color
  graySidebarHeading: '#444',
  graySidebarDivider: '#C7C7CC',
  graySidebarIcon: '#777',
  navy: '#213245',

  // Buttons
  primaryUnderlay: '#4A00E2',
  flatUnderlay: '#e9e9e9',
  primaryHover: '#4000C7',
  containedPressed: '#3500A0',
  outlinedPressed: '#E7E6FD',
  disabledColor: '#70669A',
  disabledBGColor: '#EDECEE',
  lightSecondary: '#E9E6FC',

  // Deprecated
  offBlack: '#3d4447',
  warning: '#ffc107',
  error: '#b85151',
  backDrop: 'rgba(0,0,0,.5)',

  // Info labels
  infoLight: '#d8eacc',
  infoDark: '#75a201',
  infoTint: '#D6E6F0',

  // Alerts
  alertError: '#FF0044',
  alertBGColor: '#FFE6EB'
} as const;
